<template>
  <div class="my-pooq-content-body">
  <div class="mypooq-list"
       v-infinite-scroll="loadMore"
       :infinite-scroll-distance="200"
       :infinite-scroll-throttle-delay="200">
      <my-pooq-empty-list v-if="!isLoading && movieLikeList.length === 0" info-text="나중에 볼 영화 내역이 없어요."></my-pooq-empty-list>
    <ul class="like-list">
      <!-- 좋아요 채널 리스트 -->
      <li v-for="(likeItem, index) in this.movieLikeList" :key="likeItem.title + '_' + index">
        <a href="#" @click.prevent="()=>goPlayer(likeItem)">
          <div :class="getWrapperClass(likeItem, 'thum-img like-movie')" >
            <img v-lazy="getLazyLoadObj(likeItem)" :alt="likeItem.programtitle">
            <age-tag :age-code="likeItem.targetage" content-type="mypooq" class="tag-age"></age-tag>
          </div>
          <div class="like-title-box">
            <div class="badge-group">
              <ul v-top-tag-list="{'badgeList': tagList(likeItem), 'badgeType': 'ui'}"></ul>
            </div>

            <span class="txt-title" v-html="likeItem.title"></span>
            <span class="txt-genre">
              <span>{{genre(likeItem)}}</span>
              <i class="icon-dotted"></i>
              <span>{{playtime(likeItem)}}</span>
            </span>
          </div>
        </a>
        <button type="button" class="btn-like" @click.prevent="()=>toggleSubScribe(likeItem)">
          <UnLikeButton v-if="likeItem.zzim === 'y'"/>
          <LikeButton v-else/>
        </button>
      </li>
    </ul>
  </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import { MyPooqService } from '@/common/api/api.service'
import { infiniteScroll, topTagList } from '@/common/directives'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import LikeButton from '@/assets/svg/common/ic_detail_like_off.svg'
import UnLikeButton from '@/assets/svg/common/ic_detail_like_on.svg'
import {
  COOKIE_KEY_VERIFIED_ADULT,
  MSG_COMPLETE_ADD_ZZIM_MOVIE,
  MSG_COMPLETE_DELETE_ZZIM_MOVIE
} from '@/common/constant'
import AgeTag from '@/components/tags/AgeTag'
import utils from '@/common/util/utils'
import { resizeThumbnail } from '@/common/image.filter'
import { PATH_NAME_PLAYER } from '@/common/router.const'
export default {
  name: 'MyPooqLikeMovie',
  components: {
    MyPooqEmptyList,
    AgeTag,
    LikeButton,
    UnLikeButton
  },
  props: ['subMenuIndex'],
  directives: {
    infiniteScroll,
    topTagList
  },
  data () {
    return {
      movieLikeList: [],
      offset: 0,
      limit: 20,
      endOfList: false,
      showEmptyList: false,
      isLoading: false,
      device: utils.cookies.getDevice(),
      adultConfirm: utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) === '1'
    }
  },
  methods: {
    goPlayer (movieItem) {
      if (this.device === 'mobile') {
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: {
            section: 'movie'
          },
          query: { movieid: movieItem.movieid, referer: this.$route.fullPath }
        })
      } else {
        location.href = 'captvpooq://player/movie?movieid=' + movieItem.movieid
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.zzim({
        offset: this.offset,
        limit: this.limit,
        contenttype: 'movie'
      }).then(({ data }) => {
        const resList = get(data, ['0', 'list'], [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.movieLikeList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.movieLikeList = this.movieLikeList.concat(resList)
        this.isLoading = false
      })
    },
    toggleSubScribe (likeItem) {
      if (likeItem.zzim === 'y') {
        MyPooqService.deleteZzim({
          contenttype: 'movie',
          contentids: [likeItem.movieid],
          delalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_DELETE_ZZIM_MOVIE })
          this.$nextTick(() => {
            likeItem.zzim = 'n'
          })
        })
      } else {
        MyPooqService.setZzim({
          contenttype: 'movie',
          contentid: likeItem.movieid,
          addalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_ADD_ZZIM_MOVIE })
          this.$nextTick(() => {
            likeItem.zzim = 'y'
          })
        })
      }
    },
    getLazyLoadObj (likeItem) {
      return {
        src: resizeThumbnail(likeItem.image, { width: 176, height: 264, quality: 75, multiply: 3 }),
        error: '/img/common/img_default_thum_1.png',
        loading: '/img/common/img_default_thum_1.png'
      }
    },
    getWrapperClass (item, defaultClass) {
      if (item.targetage >= 21 && !this.adultConfirm) {
        return defaultClass + ' adult'
      } else {
        return defaultClass
      }
    },
    genre (item) {
      return get(item, 'genrename', '')
    },
    playtime (item) {
      return Math.floor(get(item, 'playtime', 0) / 60) + '분'
    },
    tagList (item) {
      return get(item, 'top_taglist', []).concat(get(item, 'bottom_taglist', []))
    }
  }
}
</script>

<style scoped>
  .mypooq-list{
    height: auto;
  }
  .like-movie img {
    width: 100%;
    height: 100%;
  }
  .like-movie{
    position: relative;
  }
  .tag-age {
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .btn-like{
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 9px;
  }
  .vod-lock-21::after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8) url(../../../assets/images/ic-thum-age-adult.png) center no-repeat;
    background-size: 44px auto;
  }
</style>
